export default "__VITE_ASSET__BcTTKhi4__"